/* eslint-disable max-len */
import EmptyScreen from "../../../../CommonComponent/ListingScreens/EmptyScreen";
import NoSearchScreen from "../../../../CommonComponent/ListingScreens/NoSearchScreen";
import TableHeader from "../../../../CommonComponent/ListingScreens/TableHeader";
import Bids from "./bids"
import BidsShimmer from "./bidsShimmer"
import React from "react";

export default function ListingBody({currentSortColumn, handleSort, searchParam, bids, searchValue, loadBids,
    auctionData, loading}){

    const columns = [
        { label: "Lot no.", sortKey: "lot_number", testId: "lot_no", minWidth: "120px" },
        { label: "", minWidth: "120px" },
        { label: "Title", sortKey: "lot_title", testId: "title", minWidth: "130px" },
        { label: "Paddle no.", sortKey: "paddle_number", testId: "paddle_no", minWidth: "130px" },
        { label: "Bidder name", sortKey: "name", testId: "bidder_name", minWidth: "170px" },
        { label: "Status", sortKey: "bid_status", testId: "bidder_status", minWidth: "111px" },
        { label: "Bid", sortKey: "bid_amount", testId: "bid", minWidth: "80px" },
        { label: "Latest bid", sortKey: "updated_at", testId: "sort-paddle", minWidth: "200px" },
    ];

    return(
        <div className="customScrollbar pt-2 overflow-x-auto mb-10 z-0 relative border-[#DEDEDE] border rounded-lg mt-4">
            <div className="z-0  xl:w-full w-fit" style={{ transform: 'rotateX(180deg)' }}>
                <table aria-label="Outside Table" className="w-full overflow-auto table-auto" 
                    style={{transform: "rotateX(-180deg)"}} >
                    <TableHeader currentSortColumn={currentSortColumn} handleSort={handleSort} columns={columns} />
                    <tbody>
                        {(bids.length > 0 && !loadBids && !loading) && (
                            <Bids bids={bids} auctionData={auctionData} />
                        )}
                        {(searchParam.get('search_term')!== null && searchValue !== '' && bids.length===0 && !loadBids ) && 
                            <NoSearchScreen searchValue={searchValue} cols={8} />
                        }
                        {(searchParam.get('search_term')=== null && searchValue === '' && !loadBids && bids.length===0 && !loading) && 
                            <EmptyScreen message="No bids found" cols={8} />
                        } 
                        {(loadBids || loading) && <BidsShimmer/> }
                    </tbody>
                </table>
            </div>
        </div>
    )
}